import type {ComponentStageData, ComponentStageHeuristicDefinition, PluginContext} from '../../../types'
import {getParent} from '../../common'
import {
    getMeasurementsPointer,
    getSourceLayoutPointer,
    getTargetLayoutPointer
} from '../../../conversionDal/utils/pointer'
import {updateHorizontalMargins, updateComponentWidth, getMaxWidth} from '../common'

const isInHorizontalStack = (componentStageData: ComponentStageData): boolean => {
    const {conversionDal, componentPointer} = componentStageData
    const parentPointer = getParent(conversionDal, componentPointer)
    if (!parentPointer) return false
    const targetLayout = conversionDal.get(getTargetLayoutPointer(parentPointer))
    return targetLayout?.containerLayout?.direction === 'row'
}

const updateHorizontalStackItemMargins = (componentStageData: ComponentStageData, contextHelper: PluginContext) => {
    const {conversionDal, componentPointer} = componentStageData
    const {itemLayout} = conversionDal.get(getSourceLayoutPointer(componentPointer))
    const left = itemLayout?.margins?.left?.value ?? 0
    const right = itemLayout?.margins?.right?.value ?? 0
    updateHorizontalMargins(componentStageData, contextHelper, left, undefined, false, right)
}

export const horizontalSpacingHeuristicsStack: ComponentStageHeuristicDefinition[] = [
    {
        predicate: isInHorizontalStack,
        apply: (componentStageData: ComponentStageData, contextHelper?: PluginContext) =>
            updateHorizontalStackItemMargins(componentStageData, contextHelper!),
        heuristicCode: 'HORIZONTAL STACK ITEM HORIZONTAL MARGINS'
    },
    {
        predicate: () => true,
        apply: (componentStageData: ComponentStageData, contextHelper?: PluginContext) =>
            updateHorizontalMargins(componentStageData, contextHelper!, 0),
        heuristicCode: 'VERTICAL STACK ITEM NO HORIZONTAL MARGIN'
    }
]

export const widthHeuristicsStack: ComponentStageHeuristicDefinition[] = [
    {
        predicate: isInHorizontalStack,
        apply: (componentStageData: ComponentStageData, contextHelper?: PluginContext) => {
            const {initialSnapshot, componentPointer} = componentStageData
            const {width} = initialSnapshot.getValue(getMeasurementsPointer(componentPointer))
            const maxWidth = getMaxWidth(componentStageData, contextHelper!)
            updateComponentWidth(componentStageData, contextHelper!, Math.min(width, maxWidth))
        },
        heuristicCode: 'HORIZONTAL STACK ITEM KEEP DESKTOP WIDTH'
    },
    {
        predicate: () => true,
        apply: (componentStageData: ComponentStageData, contextHelper?: PluginContext) => {
            updateComponentWidth(componentStageData, contextHelper!, getMaxWidth(componentStageData, contextHelper!))
        },
        heuristicCode: 'STACK ITEM FULL WIDTH'
    }
]
